import { TrialRegionStatus } from '../constants/TrialRegionStatus';
import { TrialRegionActionType, TrialRegionActions } from '../actions/trialRegions/types/actions';
import { TrialRegionsState } from '../actions/trialRegions/types/state';

export const initialState: Partial<TrialRegionsState> = {
  status: TrialRegionStatus.IDLE,
};

const trialRegionReducer = (
  state: Partial<TrialRegionsState> = initialState,
  action: TrialRegionActions
): Partial<TrialRegionsState> => {
  switch (action.type) {
    case TrialRegionActionType.FetchTrialRegions:
      return { ...state, status: TrialRegionStatus.PENDING };
    case TrialRegionActionType.FetchTrialRegionsResolved:
      return {
        ...state,
        experimentalUnits: action.payload?.experimentalUnits || [],
        status: TrialRegionStatus.RESOLVED
      };
    case TrialRegionActionType.FetchTrialRegionsRejected:
      return {
        ...state,
        status: TrialRegionStatus.REJECTED,
        error: action.payload.error
      };
    default:
      return state;
  }
};

export default trialRegionReducer;
